import React from 'react';

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

export const StatusBadge: React.FC<{ tone: StatusTone; children: React.ReactNode }> = ({ tone, children }) => (
  <span className={`pill pill-${tone}`}>{children}</span>
);
